// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__tmRCE","modalBody":"MealsPop_modalBody__+OPLv"};